export class FindAllOrganisationsError {
  public static readonly type =
    '[User/Organisations] FindAllOrganisationsError';
  constructor(public readonly error: Error) {}
}
